<template>
<div id="app">
    <b-container fluid>

        <!-- Content here -->

        <headercomponent />
        <!-- For Dev -->
        <!-- <input type="number" v-model="pageNum"> -->

        <div class="npfcontainer fluid">
            <!-- ErrorCard -->
            <transition name="fade" mode="out-in">
                <div id="errorCardTop" class="errorCard" v-if="validationErrors == true">
                    <b-card class="errorCard">
                        <h1>Validation Errors</h1>

                        <ul id="example-1">
                            <li v-for="(item, index) in validationErrorsMessage" v-bind:key="validationErrorsMessage[index]">{{ item }}</li>
                        </ul>

                        <span>
                                <i>Please correct all the above validation errors before you can continue</i>
                              </span>
                    </b-card>
                </div>
            </transition>

            <transition name="fade" mode="out-in">
                <div id="page0" v-if="pageNum == 0">
                    <b-row>
                        <b-col cols="8">
                            <h1>Report online</h1>
                            <p class="lead">Use this service to report a non-emergency crime or incident to the police.</p>
                            <h2>Before you start</h2>

                            <div class="callout">
                                <p>
                                    <strong><font-awesome-icon :icon="['fas', 'phone']"></font-awesome-icon>&nbsp;&nbsp;Call 999 to report an immediate threat to life or property. (Textphone: 18000)</strong>
                                </p>
                            </div>

                            <ol>
                                <li>You'll need to provide an email address or phone number.</li>
                                <li>All reports are reviewed by the Police and if necessary we will respond by email or phone.</li>
                                <li>Your report will be sent over a secure internet connection and all information will be treated confidentially.</li>
                                <li>Please do not report via this online service if you have already made the same report by phone</li>
                                <li>
                                    There are separate reporting services for the following types of crime:
                                    <ul>
                                        <li>
                                            <a href="http://www.actionfraud.police.uk/report_fraud">
                                          Fraud and online crime
                                          <font-awesome-icon :icon="['fas', 'external-link-alt']"></font-awesome-icon>
                                        </a>
                                        </li>
                                        <li>
                                            <a href="http://www.btp.police.uk/contact_us.aspx">
                                          Crime that happened on a train or at a railway station
                                          <font-awesome-icon :icon="['fas', 'external-link-alt']"></font-awesome-icon>
                                        </a>
                                        </li>
                                    </ul>
                                </li>
                                <li>If your report relates to an incident involving a current or ex-partner, if you are able to do so please report this via phone on either 999 or 101</li>
                            </ol>

                            <div class="startbutton">
                                <b-button size="lg" variant="success" v-on:click="nextPage">
                                    Start&nbsp;&nbsp;
                                    <font-awesome-icon :icon="['fas', 'sign-in-alt']"></font-awesome-icon>
                                </b-button>
                                <br>
                                <br>
                                </div>
                        </b-col>
                        <b-col cols="4">
                            <b-card>
                                <h2 id="related-header">Other ways to report crime</h2>

                                <b-card class="cardboardTop" title="Report by phone">
                                    <p>
                                        Telephone:
                                        <b>
                                        <font-awesome-icon :icon="['fas', 'phone-volume']"></font-awesome-icon>101
                                      </b>
                                        <br>Textphone:
                                        <b>
                                        <font-awesome-icon :icon="['fas', 'keyboard']"></font-awesome-icon>18001 101
                                      </b>
                                    </p>
                                    <p>
                                        Calls to 101 cost 15p per call.
                                        <br>
                                        <a href="https://www.gov.uk/call-charges">
                                        More information about call charges
                                        <font-awesome-icon :icon="['fas', 'external-link-alt']"></font-awesome-icon>
                                      </a>
                                    </p>
                                </b-card>
                                <b-card class="cardboardTop" title="Report anonymously">
                                    <p>
                                        Contact
                                        <b>Crimestoppers</b>.
                                    </p>
                                    <p>
                                        <b>
                                        <a
                                          href="https://crimestoppers-uk.org/give-information/give-information-online/"
                                        >
                                          www.crimestoppers-uk.org
                                          <font-awesome-icon :icon="['fas', 'external-link-alt']"></font-awesome-icon>
                                        </a>
                                      </b>
                                        <br>Telephone:
                                        <b>
                                        <font-awesome-icon :icon="['fas', 'phone-volume']"></font-awesome-icon>0800 555 111
                                      </b>
                                    </p>
                                </b-card>
                            </b-card>
                        </b-col>
                    </b-row>
                </div>
            </transition>

            <transition name="fade" mode="out-in">
                <div id="page1" v-if="pageNum == 1">
                    <span class="stage">Stage 1 of 8</span>
                    <h1>Report a Crime online</h1>

                    <b-card class="cardboardTop" title="Please tell us what kind of incident you are reporting (required)">
                        <div>
                            <div v-on:click="vm.typeOfIndident ='A'" class="clickable" v-bind:class="{ npfactive: vm.typeOfIndident == 'A', npfnonActive :vm.typeOfIndident != 'A' }">
                                <input type="radio" id="one" value="A" v-model="vm.typeOfIndident">
                                <label for="one">An incident you are the victim of</label>
                            </div>
                            <br>
                            <div v-on:click="vm.typeOfIndident ='B'" class="clickable" v-bind:class="{ npfactive: vm.typeOfIndident == 'B', npfnonActive :vm.typeOfIndident != 'B' }">
                                <input type="radio" id="two" value="B" v-model="vm.typeOfIndident">
                                <label for="two">An incident you witnessed or are reporting on behalf of someone else</label>
                                <br>
                                </div>
                            </div>
                    </b-card>
                </div>
            </transition>

            <transition name="fade" mode="out-in">
                <div id="page2" v-if="pageNum == 2">
                    <span class="stage">Stage 2 of 8</span>
                    <h1>About You</h1>

                    <b-card class="cardboardTop" title="Please tell us about yourself.">
                        <div class="npfQuestionDiv">
                            <span class="npfMainQuestion">What is your name?</span>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Title</label>
                                        <b-form-input v-model="vm.ReportingPerson.title" placeholder="Enter your title"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">First Name</label>
                                        <span class="mandatory">{{mandatoryText}}</span>
                                        <b-form-input v-model="vm.ReportingPerson.firstname" placeholder="First name"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Middle Name(s)</label>
                                        <b-form-input v-model="vm.ReportingPerson.middlename" placeholder="Middle name"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Surname</label>
                                        <span class="mandatory">{{mandatoryText}}</span>
                                        <b-form-input v-model="vm.ReportingPerson.surname" placeholder="Surname"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>

                        <div class="npfQuestionDiv">
                            <span class="npfMainQuestion">What is your date of birth?</span>
                            <span class="mandatory">{{mandatoryText}}</span>
                            <b-row>
                                <b-col cols="12">
                                    <span class="npfSubQuestion">For example, 01 04 1983.</span>
                                </b-col>
                            </b-row>

                               <b-row>
                                <b-col cols="12">
                                     <date-picker class="vue-picker1" name="ReportingPersonDOB" :config="optionsPreviousDate" v-model="vm.ReportingPerson.dob">
                                    </date-picker>
                                   
                                </b-col>
                            </b-row>
                            <!-- <b-row>
                                <b-col cols="1">
                                    <label class="npfQuestion">Day</label>

                                    <b-form-input type="number" maxlength="2" size="2" v-model="vm.ReportingPerson.dobday" placeholder="01"></b-form-input>
                                </b-col>

                                <b-col cols="1">
                                    <label class="npfQuestion">Month</label>

                                    <b-form-input type="number" maxlength="2" size="2" v-model="vm.ReportingPerson.dobmonth" placeholder="04"></b-form-input>
                                </b-col>

                                <b-col cols="2">
                                    <label class="npfQuestion">Year</label>

                                    <b-form-input type="number" maxlength="4" size="4" v-model="vm.ReportingPerson.dobyear" placeholder="1983"></b-form-input>
                                </b-col>
                            </b-row> -->
                        </div>

                        <div class="npfQuestionDiv">
                            <span class="npfMainQuestion">How can we contact you?</span>

                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Phone Number</label>
                                        <b-form-input v-model="vm.ReportingPerson.phonenumber" placeholder="Phone Number"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Alternative phone number</label>
                                        <b-form-input v-model="vm.ReportingPerson.phonenumberother" placeholder="Alternative Phone Number"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>

                            <transition name="fade" mode="out-in">
                                <div v-if="vm.ReportingPerson.phonenumber || vm.ReportingPerson.phonenumberother">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <p class="npfconfirm">
                                                    We may phone you on
                                                    <br>
                                                    <transition name="fade" mode="out-in">
                                                        <span v-if="vm.ReportingPerson.phonenumber" class="boldFont">{{vm.ReportingPerson.phonenumber}}</span>
                                                    </transition>
                                                    <transition name="fade" mode="out-in">
                                                        <span v-if="vm.ReportingPerson.phonenumberother && vm.ReportingPerson.phonenumber">&nbsp;or&nbsp;</span>
                                                    </transition>
                                                    <transition name="fade" mode="out-in">
                                                        <span v-if="vm.ReportingPerson.phonenumberother" class="boldFont">{{vm.ReportingPerson.phonenumberother}}</span>
                                                    </transition>
                                                    <br>If we need to speak to you we will call within 24 hours. The call may come from a withheld number.
                                                    </p>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </div>
                            </transition>

                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Email address</label>
                                        <span class="mandatory">{{mandatoryText}}</span>
                                        <b-form-input v-model="vm.ReportingPerson.email" placeholder="Email"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <transition name="fade" mode="out-in">
                                <div v-if="vm.ReportingPerson.email">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <p class="npfconfirm">
                                                    We may send emails to
                                                    <br>
                                                    <transition name="fade" mode="out-in">
                                                        <span v-if="vm.ReportingPerson.email" class="boldFont">{{vm.ReportingPerson.email}}</span>
                                                    </transition>
                                                </p>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </div>
                            </transition>
                        </div>

                        <div class="npfQuestionDiv">
                            <span class="npfMainQuestion">What is your home address?</span>
                            <span class="mandatory">{{mandatoryText}}</span>
                            <br>

                            <span class="npfSubQuestion">Please tell us your address in case we need to contact you at home.</span>
                            <div v-bind:class="{ npfnonActive: vm.ReportingPerson.Address.NotProvideAddress == true } ">
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Building name</label>
                                            <b-form-input v-model="vm.ReportingPerson.Address.BuidlingName" placeholder="Building name"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Building number</label>
                                            <b-form-input v-model="vm.ReportingPerson.Address.BuildingNumber" placeholder="Building number"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Street</label>
                                            <b-form-input v-model="vm.ReportingPerson.Address.Street" placeholder="Street"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Town or city</label>
                                            <b-form-input v-model="vm.ReportingPerson.Address.Town" placeholder="Town or city"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">County</label>
                                            <b-form-input v-model="vm.ReportingPerson.Address.County" placeholder="County"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Postcode</label>
                                            <b-form-input v-model="vm.ReportingPerson.Address.PostCode" placeholder="Postcode"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </div>
                            <br>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <div class="clickable"  v-on:click="vm.ReportingPerson.Address.NotProvideAddress = !vm.ReportingPerson.Address.NotProvideAddress" v-bind:class="{ npfnonActive: vm.ReportingPerson.Address.NotProvideAddress != true } ">
                                            <div class="npfpadding">
<i class="far fa-square fa-lg" v-if="vm.ReportingPerson.Address.NotProvideAddress == false">&nbsp;&nbsp;</i>

<i class="far fa-check-square fa-lg" v-if="vm.ReportingPerson.Address.NotProvideAddress == true">&nbsp;&nbsp;</i>
                                                <input style="display:none;" class="npfcheckbox" type="checkbox"  v-model="vm.ReportingPerson.Address.NotProvideAddress">
                                                <span>I can not provide the address</span>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>

                        <b-card>
                            <div class="npfQuestionDiv">
                                <span class="npfMainQuestion">The following questions are optional. Your answers will be used anonymously for crime reporting statistics.</span>
                            </div>
                            <div class="npfQuestionDiv">
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Gender</label>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.gender = 'F'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.gender == 'F', npfnonActive :vm.ReportingPerson.gender != 'F' }">
                                                <input type="radio" id="rpGenderFemale" value="F" v-model="vm.ReportingPerson.gender">
                                                <label for="rpGenderFemale">Female</label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.gender = 'M'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.gender == 'M', npfnonActive :vm.ReportingPerson.gender != 'M' }">
                                                <input type="radio" id="rpGenderMale" value="M" v-model="vm.ReportingPerson.gender">
                                                <label for="rpGenderMale">Male</label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.gender = 'O'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.gender == 'O', npfnonActive :vm.ReportingPerson.gender != 'O' }">
                                                <input type="radio" id="rpGenderOther" value="O" v-model="vm.ReportingPerson.gender">
                                                <label for="rpGenderOther">Other</label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.gender = 'PNS'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.gender == 'PNS', npfnonActive :vm.ReportingPerson.gender != 'PNS' }">
                                                <input type="radio" id="rpGenderPNS" value="PNS" v-model="vm.ReportingPerson.gender">
                                                <label for="rpGenderPNS">Prefer not to say</label>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </div>

                            <div class="npfQuestionDiv">
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">What is your ethnicity?</label>
                                            <b-form-select v-model="vm.ReportingPerson.ethnicity" :options="ethnicity"></b-form-select>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </div>

                            <div class="npfQuestionDiv">
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Do you have a disability or access need?</label>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.disability = 'Yes'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.disability == 'Yes', npfnonActive :vm.ReportingPerson.disability != 'Yes' }">
                                                <input type="radio" id="rpDisYes" value="Yes" v-model="vm.ReportingPerson.disability">
                                                <label for="rpDisYes">Yes</label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.disability = 'No'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.disability == 'No', npfnonActive :vm.ReportingPerson.disability != 'No' }">
                                                <input type="radio" id="rpDisNo" value="No" v-model="vm.ReportingPerson.disability">
                                                <label for="rpDisNo">No</label>
                                            </div>
                                        </b-col>
                                        <b-col cols="2">
                                            <div v-on:click="vm.ReportingPerson.disability = 'PNS'" class="clickable" v-bind:class="{ npfactive: vm.ReportingPerson.disability == 'PNS', npfnonActive :vm.ReportingPerson.disability != 'PNS' }">
                                                <input type="radio" id="rpDisPNS" value="PNS" v-model="vm.ReportingPerson.disability">
                                                <label for="rpDisPNS">Don't know / Prefer not to say</label>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <div class="npfconfirm" v-if="vm.ReportingPerson.disability == 'Yes'">
                                    <b-form-group>
                                        <span class="npfQuestion">Please provide details of your disability or access need</span>
                                        <br>
                                        <span class="npfSubQuestion">This information will be used to ensure reasonable adjustments are made</span>
                                        <b-form-textarea id="textarea" v-model="vm.ReportingPerson.disabilityDetails" placeholder="Details of your disability or access need..." rows="5" max-rows="12"></b-form-textarea>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-card>
                    </b-card>
                    <br>
                    <div v-if="vm.typeOfIndident =='B'">

                        <h1>About the victim</h1>

                        <b-card class="cardboardTop" title="Please tell us about the victim.">

                            <div class="npfQuestionDiv">
                                <span class="npfMainQuestion">Do you know the victim?</span>
                                <div>
                                    <div v-on:click="vm.doyouknowntoVic ='Yes'" class="clickable" v-bind:class="{ npfactive: vm.doyouknowntoVic == 'Yes', npfnonActive :vm.doyouknowntoVic != 'Yes' }">
                                        <input type="radio" id="kvicYes" value="Yes" v-model="vm.doyouknowntoVic">
                                        <label for="kvicYes">Yes</label>
                                    </div>
                                    <br>
                                    <div v-on:click="vm.doyouknowntoVic ='No'" class="clickable" v-bind:class="{ npfactive: vm.doyouknowntoVic == 'No', npfnonActive :vm.doyouknowntoVic != 'No' }">
                                        <input type="radio" id="kvicNo" value="No" v-model="vm.doyouknowntoVic">
                                        <label for="kvicNo">No</label>
                                    </div>
                                </div>

                            </div>

                            <div class="npfQuestionDiv">
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Is the victim a Person or an Organisation?</label>
                                            <b-form-select v-model="vm.Victim.vicType" :options="victimType"></b-form-select>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </div>

                            <div class="npfQuestionDiv" v-if="vm.Victim.vicType == 'Organisation'">
                                <span class="npfMainQuestion">Organisation's Details?</span>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Organisation Name</label>
                                            <b-form-input v-model="vm.Victim.orgName" placeholder="Enter the orgs name"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Contact Name in Organisation</label>

                                            <b-form-input v-model="vm.Victim.orgContactPerson" placeholder="A single point of contact in the org"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>

                            </div>

                            <div class="npfQuestionDiv" v-if="vm.Victim.vicType == 'Person'">
                                <span class="npfMainQuestion">What is the victim's name?</span>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Title</label>
                                            <b-form-input v-model="vm.Victim.title" placeholder="Enter their title"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">First Name</label>

                                            <b-form-input v-model="vm.Victim.firstname" placeholder="First name"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Middle Name(s)</label>
                                            <b-form-input v-model="vm.Victim.middlename" placeholder="Middle name"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Surname</label>

                                            <b-form-input v-model="vm.Victim.surname" placeholder="Surname"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </div>

                            <div class="npfQuestionDiv" v-if="vm.Victim.vicType == 'Person'">
                                <span class="npfMainQuestion">What is their date of birth?</span>

                                <b-row>
                                    <b-col cols="12">
                                        <span class="npfSubQuestion">For example, 01 04 1983.</span>
                                    </b-col>
                                </b-row>

      <b-row>
                                <b-col cols="12">
                                     <date-picker class="vue-picker1" name="ReportingVicDOB" :config="optionsPreviousDate" v-model="vm.Victim.dob">
                                    </date-picker>
                                   
                                </b-col>
                            </b-row>

                                <!-- <b-row>
                                    <b-col cols="1">
                                        <label class="npfQuestion">Day</label>

                                        <b-form-input type="number" v-model="vm.Victim.dobday" placeholder="01"></b-form-input>
                                    </b-col>

                                    <b-col cols="1">
                                        <label class="npfQuestion">Month</label>

                                        <b-form-input type="number" v-model="vm.Victim.dobmonth" placeholder="04"></b-form-input>
                                    </b-col>

                                    <b-col cols="2">
                                        <label class="npfQuestion">Year</label>

                                        <b-form-input type="number" v-model="vm.Victim.dobyear" placeholder="1983"></b-form-input>
                                    </b-col>
                                </b-row> -->
                            </div>

                            <div class="npfQuestionDiv" v-if="vm.Victim.vicType != ''">
                                <span class="npfMainQuestion">Do you known their contact details?</span>

                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Phone Number</label>
                                            <b-form-input v-model="vm.Victim.phonenumber" placeholder="Phone Number"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Alternative phone number</label>
                                            <b-form-input v-model="vm.Victim.phonenumberother" placeholder="Alternative Phone Number"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.Victim.phonenumber || vm.Victim.phonenumberother">
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <p class="npfconfirm">
                                                        We may phone the victim on
                                                        <br>
                                                        <transition name="fade" mode="out-in">
                                                            <span v-if="vm.Victim.phonenumber" class="boldFont">{{vm.Victim.phonenumber}}</span>
                                                        </transition>
                                                        <transition name="fade" mode="out-in">
                                                            <span v-if="vm.Victim.phonenumberother && vm.Victim.phonenumber">&nbsp;or&nbsp;</span>
                                                        </transition>
                                                        <transition name="fade" mode="out-in">
                                                            <span v-if="vm.Victim.phonenumberother" class="boldFont">{{vm.Victim.phonenumberother}}</span>
                                                        </transition>
                                                        <br>If we need to the victim we will call within 24 hours. The call may come from a withheld number.
                                                        </p>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </div>
                                </transition>

                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <label class="npfQuestion">Email address</label>

                                            <b-form-input v-model="vm.Victim.email" placeholder="Email"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.Victim.email">
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <p class="npfconfirm">
                                                        We may send emails to
                                                        <br>
                                                        <transition name="fade" mode="out-in">
                                                            <span v-if="vm.Victim.email" class="boldFont">{{vm.Victim.email}}</span>
                                                        </transition>
                                                    </p>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </div>
                                </transition>
                            </div>

                            <div class="npfQuestionDiv" v-if="vm.Victim.vicType != ''">
                                <span class="npfMainQuestion">What is the victim's address?</span>

                                <br>

                                <span class="npfSubQuestion">Please tell us their address in case we need to contact them.</span>
                                <div v-bind:class="{ npfnonActive: vm.Victim.Address.NotProvideAddress == true } ">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Building name</label>
                                                <b-form-input v-model="vm.Victim.Address.BuidlingName" placeholder="Building name"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Building number</label>
                                                <b-form-input v-model="vm.Victim.Address.BuildingNumber" placeholder="Building number"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Street</label>
                                                <b-form-input v-model="vm.Victim.Address.Street" placeholder="Street"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Town or city</label>
                                                <b-form-input v-model="vm.Victim.Address.Town" placeholder="Town or city"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">County</label>
                                                <b-form-input v-model="vm.Victim.Address.County" placeholder="County"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Postcode</label>
                                                <b-form-input v-model="vm.Victim.Address.PostCode" placeholder="Postcode"></b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </div>

                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <div  class="clickable" v-on:click="vm.Victim.Address.NotProvideAddress = !vm.Victim.Address.NotProvideAddress" v-bind:class="{ npfnonActive: vm.Victim.Address.NotProvideAddress != true } ">
                                                <div class="npfpadding">
                                                    <i class="far fa-square fa-lg" v-if="vm.Victim.Address.NotProvideAddress == false">&nbsp;&nbsp;</i>

<i class="far fa-check-square fa-lg" v-if="vm.Victim.Address.NotProvideAddress == true">&nbsp;&nbsp;</i>
                                                    <input style="display:none;" class="npfcheckbox" type="checkbox" v-model="vm.Victim.Address.NotProvideAddress">
                                                    <span>I can not provide the address</span>
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </div>

                            <b-card v-if="vm.Victim.vicType == 'Person'">
                                <div class="npfQuestionDiv">
                                    <span class="npfMainQuestion">The following questions are optional. Your answers will be used anonymously for crime reporting statistics.</span>
                                </div>
                                <div class="npfQuestionDiv">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Victim's Gender</label>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.gender = 'F'" class="clickable" v-bind:class="{ npfactive: vm.Victim.gender == 'F', npfnonActive :vm.Victim.gender != 'F' }">
                                                    <input type="radio" id="vicGenderFemalevic" value="F" v-model="vm.Victim.gender">
                                                    <label for="vicGenderFemalevic">Female</label>
                                                </div>
                                            </b-col>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.gender = 'M'" class="clickable" v-bind:class="{ npfactive: vm.Victim.gender == 'M', npfnonActive :vm.Victim.gender != 'M' }">
                                                    <input type="radio" id="vicGenderMalevic" value="M" v-model="vm.Victim.gender">
                                                    <label for="vicGenderMalevic">Male</label>
                                                </div>
                                            </b-col>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.gender = 'O'" class="clickable" v-bind:class="{ npfactive: vm.Victim.gender == 'O', npfnonActive :vm.Victim.gender != 'O' }">
                                                    <input type="radio" id="viGenderOthervic" value="O" v-model="vm.Victim.gender">
                                                    <label for="vicGenderOthervic">Other</label>
                                                </div>
                                            </b-col>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.gender = 'PNS'" class="clickable" v-bind:class="{ npfactive: vm.Victim.gender == 'PNS', npfnonActive :vm.Victim.gender != 'PNS' }">
                                                    <input type="radio" id="vicGenderPNSvic" value="PNS" v-model="vm.Victim.gender">
                                                    <label for="vicGenderPNSvic">Prefer not to say</label>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </div>

                                <div class="npfQuestionDiv">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">What is their ethnicity?</label>
                                                <b-form-select v-model="vm.Victim.ethnicity" :options="ethnicity"></b-form-select>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </div>

                                <div class="npfQuestionDiv">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <label class="npfQuestion">Do they have a disability or access need?</label>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.disability = 'Yes'" class="clickable" v-bind:class="{ npfactive: vm.Victim.disability == 'Yes', npfnonActive :vm.Victim.disability != 'Yes' }">
                                                    <input type="radio" id="vicDisYesvic" value="Yes" v-model="vm.Victim.disability">
                                                    <label for="vicDisYesvic">Yes</label>
                                                </div>
                                            </b-col>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.disability = 'No'" class="clickable" v-bind:class="{ npfactive: vm.Victim.disability == 'No', npfnonActive :vm.Victim.disability != 'No' }">
                                                    <input type="radio" id="vicDisNovic" value="No" v-model="vm.Victim.disability">
                                                    <label for="vicDisNovic">No</label>
                                                </div>
                                            </b-col>
                                            <b-col cols="2">
                                                <div v-on:click="vm.Victim.disability = 'PNS'" class="clickable" v-bind:class="{ npfactive: vm.Victim.disability == 'PNS', npfnonActive :vm.Victim.disability != 'PNS' }">
                                                    <input type="radio" id="vicDisPNSvic" value="PNS" v-model="vm.Victim.disability">
                                                    <label for="vicDisPNSvic">Don't know / Prefer not to say</label>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                    <div class="npfconfirm" v-if="vm.Victim.disability == 'Yes'">
                                        <b-form-group>
                                            <span class="npfQuestion">Please provide details of their disability or access need</span>
                                            <br>
                                            <span class="npfSubQuestion">This information will be used to ensure reasonable adjustments are made</span>
                                            <b-form-textarea id="textarea" v-model="vm.Victim.disabilityDetails" placeholder="Details of the victim's disability or access need..." rows="5" max-rows="12"></b-form-textarea>
                                        </b-form-group>
                                    </div>
                                </div>
                            </b-card>
                        </b-card>
                    </div>

                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div id="page3" v-if="pageNum == 3">
                    <span class="stage">Stage 3 of 8</span>
                    <h1>About the incident</h1>
                    <b-card class="cardboardTop" title="Please tell us about the incident.">
                        <span class="npfSubQuestion">Questions are optional unless marked as required.</span>
                        <div class="npfQuestionDiv">
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">What happened?</label>
                                        <br>
                                        <span class="npfSubQuestion">Select all that apply. You'll be able to tell us more later.</span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12">
                                        <b-card v-on:click="TypeofIncidentClicked('Something was stolen')" class="clickable" v-bind:class="{ npfactive: vm.incident.typeOfIncident.indexOf('Something was stolen') > -1  , npfnonActive :vm.incident.typeOfIncident.indexOf('Something was stolen') == -1 }">
                                            <i class="far fa-check-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Something was stolen') > -1">&nbsp;&nbsp;</i>
                                            <i class="far fa-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Something was stolen') == -1">&nbsp;&nbsp;</i>
                                            
                                            <input style="display:none;" type="checkbox" value="Something was stolen" v-model="vm.incident.typeOfIncident">
                                            <span class="npfQuestion">Something was stolen</span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">For example, an item was taken, with or without force, in the street, at home or in any other location.</span>
                                        </b-card>
                                        <br>
                                        <b-card v-on:click="TypeofIncidentClicked('Physical or verbal assault')" class="clickable" v-bind:class="{ npfactive: vm.incident.typeOfIncident.indexOf('Physical or verbal assault') > -1  , npfnonActive :vm.incident.typeOfIncident.indexOf('Physical or verbal assault') == -1 }">
                                              <i class="far fa-check-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Physical or verbal assault') > -1">&nbsp;&nbsp;</i>
                                             <i class="far fa-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Physical or verbal assault') == -1">&nbsp;&nbsp;</i>
                                            <input  style="display:none;" type="checkbox" value="Physical or verbal assault" v-model="vm.incident.typeOfIncident">
                                            <span class="npfQuestion">Physical or verbal assault</span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">For example, hate crimes, racial slurs or physical violence from a known or unknown person.</span>
                                        </b-card>
                                        <br>
                                        <b-card v-on:click="TypeofIncidentClicked('Criminal damage or anti-social behaviour')" class="clickable" v-bind:class="{ npfactive: vm.incident.typeOfIncident.indexOf('Criminal damage or anti-social behaviour') > -1  , npfnonActive :vm.incident.typeOfIncident.indexOf('Criminal damage or anti-social behaviour') == -1 }">
                                             <i class="far fa-check-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Criminal damage or anti-social behaviour') > -1">&nbsp;&nbsp;</i>
                                             <i class="far fa-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Criminal damage or anti-social behaviour') == -1">&nbsp;&nbsp;</i>
                                            <input  style="display:none;" type="checkbox" value="Criminal damage or anti-social behaviour" v-model="vm.incident.typeOfIncident">
                                            <span class="npfQuestion">Criminal damage or anti-social behaviour</span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">For example, damage to personal property, vandalism, harassment and bullying.</span>
                                        </b-card>
                                        <br>
                                        <b-card v-on:click="TypeofIncidentClicked('Witnessed something suspicious')" class="clickable" v-bind:class="{ npfactive: vm.incident.typeOfIncident.indexOf('Witnessed something suspicious') > -1  , npfnonActive :vm.incident.typeOfIncident.indexOf('Witnessed something suspicious') == -1 }">
                                                  <i class="far fa-check-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Witnessed something suspicious') > -1">&nbsp;&nbsp;</i>
                                            <i class="far fa-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Witnessed something suspicious') == -1">&nbsp;&nbsp;</i>
                                            <input  style="display:none;" type="checkbox" value="Witnessed something suspicious" v-model="vm.incident.typeOfIncident">
                                            <span class="npfQuestion">Witnessed something suspicious</span>
                                            <br>
                                            <!-- <span
                                          class="npfSubQuestion npfpad"
                                        >For example, damage to personal property, vandalism, harassment and bullying.</span>-->
                                        </b-card>
                                        <br>
                                        <b-card v-on:click="TypeofIncidentClicked('Something else not in this list')" class="clickable" v-bind:class="{ npfactive: vm.incident.typeOfIncident.indexOf('Something else not in this list') > -1  , npfnonActive :vm.incident.typeOfIncident.indexOf('Something else not in this list') == -1 }">
                                                  <i class="far fa-check-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Something else not in this list') > -1">&nbsp;&nbsp;</i>
                                           <i class="far fa-square fa-lg" v-if="vm.incident.typeOfIncident.indexOf('Something else not in this list') == -1">&nbsp;&nbsp;</i>
                                            <input  style="display:none;" type="checkbox" value="Something else not in this list" v-model="vm.incident.typeOfIncident">
                                            <span class="npfQuestion">Something else not in this list</span>
                                            <br>
                                            <!-- <span
                                          class="npfSubQuestion npfpad"
                                        >For example, damage to personal property, vandalism, harassment and bullying.</span>-->
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>

                        <div class="npfQuestionDiv">
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">When did it happen?</label>
                                        <br>
                                        <span class="npfSubQuestion">If you don't know exactly, please tell us the earliest and latest dates and times it could have happened between.</span>
                                    </b-col>
                                </b-row>
                            </b-form-group>

                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Start</label>
                                        <br>
                                        <span class="npfSubQuestion">For example, 25/04/2018 10:30am.</span>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
      <b-row>
                                <b-col cols="12">
                                     <date-picker class="vue-picker1" name="incidnetST" :config="optionsdt" v-model="vm.incident.startDateTime">
                                    </date-picker>
                                   
                                </b-col>
                            </b-row>



                                <!-- <b-row>
                                    <b-col cols="1">
                                        <label class="npfQuestion">Day</label>

                                        <b-form-input type="number" v-model="vm.incident.startday" placeholder="01"></b-form-input>
                                    </b-col>

                                    <b-col cols="1">
                                        <label class="npfQuestion">Month</label>

                                        <b-form-input type="number" v-model="vm.incident.startmonth" placeholder="04"></b-form-input>
                                    </b-col>

                                    <b-col cols="2">
                                        <label class="npfQuestion">Year</label>

                                        <b-form-input type="number" v-model="vm.incident.startyear" placeholder="1983"></b-form-input>
                                    </b-col>
                                    <b-col cols="2">
                                        <label class="npfQuestion">Time</label>

                                        <b-form-input v-model="vm.incident.startTime" placeholder="10:30 AM"></b-form-input>
                                    </b-col>
                                </b-row> -->
                            </b-form-group>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">End</label>
                                        <br>
                                        <span class="npfSubQuestion">For example, 25/04/2018 10:45am.</span>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <b-form-group>
                                    <b-row>
                                <b-col cols="12">
                                     <date-picker class="vue-picker1" name="incidnetST" :config="optionsdt" v-model="vm.incident.endDateTime">
                                    </date-picker>
                                   
                                </b-col>
                            </b-row>
                                <!-- <b-row>
                                    <b-col cols="1">
                                        <label class="npfQuestion">Day</label>

                                        <b-form-input type="number" v-model="vm.incident.endday" placeholder="01"></b-form-input>
                                    </b-col>

                                    <b-col cols="1">
                                        <label class="npfQuestion">Month</label>

                                        <b-form-input type="number" v-model="vm.incident.endmonth" placeholder="04"></b-form-input>
                                    </b-col>

                                    <b-col cols="2">
                                        <label class="npfQuestion">Year</label>

                                        <b-form-input type="number" v-model="vm.incident.endyear" placeholder="1983"></b-form-input>
                                    </b-col>
                                    <b-col cols="2">
                                        <label class="npfQuestion">Time</label>

                                        <b-form-input v-model="vm.incident.endtime" placeholder="10:30 AM"></b-form-input>
                                    </b-col>
                                </b-row> -->
                            </b-form-group>
                        </div>
                        <div class="npfQuestionDiv">
                            <span class="npfMainQuestion">Where did it happen?  </span> <span class="npfSubQuestion">(Only if you know the full postal address e.g. postcode etc)</span>

                            <br>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <div v-on:click="vm.incident.Address.NotProvideAddress = !vm.incident.Address.NotProvideAddress" class="clickable" v-bind:class="{ npfnonActive: vm.incident.Address.NotProvideAddress != true } ">
                                            <div class="npfpadding">
                          <i class="far fa-check-square fa-lg" v-if="vm.incident.Address.NotProvideAddress == true">&nbsp;&nbsp;</i>
 <i class="far fa-square fa-lg" v-if="vm.incident.Address.NotProvideAddress == false">&nbsp;&nbsp;</i>

                                                <input style="display:none;" class="npfcheckbox" type="checkbox" v-model="vm.incident.Address.NotProvideAddress">
                                                <span>I know the address</span>
                                            </div>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                            <transition name="fade" mode="out-in">
                                <div v-if="vm.incident.Address.NotProvideAddress == true">
                                    <span class="npfSubQuestion">Please tell the address the incident happend.</span>
                                    <div>
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <label class="npfQuestion">Building name</label>
                                                    <b-form-input v-model="vm.incident.Address.BuidlingName" placeholder="Building name"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <label class="npfQuestion">Building number</label>
                                                    <b-form-input v-model="vm.incident.Address.BuildingNumber" placeholder="Building number"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <label class="npfQuestion">Street</label>
                                                    <b-form-input v-model="vm.incident.Address.Street" placeholder="Street"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <label class="npfQuestion">Town or city</label>
                                                    <b-form-input v-model="vm.incident.Address.Town" placeholder="Town or city"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <label class="npfQuestion">County</label>
                                                    <b-form-input v-model="vm.incident.Address.County" placeholder="County"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <label class="npfQuestion">Postcode</label>
                                                    <b-form-input v-model="vm.incident.Address.PostCode" placeholder="Postcode"></b-form-input>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </div>
                                </div>
                            </transition>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <label class="npfQuestion">Describe the location</label> <span v-if="vm.incident.Address.NotProvideAddress == false" class="mandatory">{{mandatoryText}}</span>
                                        <br>
                                        <span class="npfSubQuestion">If you don't know the address, or if you can describe the location in more detail.</span>
                                        <b-form-textarea v-model="vm.incident.decriptionOfLocation" placeholder="Describe the location use landmarks where possible e.g. schools, churches etc" rows="5" max-rows="12"></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>
                        <div class="npfQuestionDiv">
                            <span class="npfMainQuestion">Describe the incident in your own words</span>
                            <span class="mandatory">{{mandatoryText}}</span>
                            <br>
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <span class="npfSubQuestion">You'll be able to tell us about any suspects, personal belongings, evidence and related incidents later.</span>
                                        <b-form-textarea v-model="vm.incident.decribeIncident" placeholder="Describe the incident in your own words" rows="5" max-rows="12"></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>
                    </b-card>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div id="page4" v-if="pageNum == 4">
                    <span class="stage">Stage 4 of 8</span>
                    <h1>About any suspects</h1>
                    <span class="npfSubQuestion">If you have any information about the person or people who carried out the crime, please tell us about them.
                <br>
                Otherwise, continue to the next page.</span>

                    <b-card class="cardboardTop" title="Suspects.">
                        <b-button v-if="addSuspect == false" v-on:click="addsuspectMainButton" variant="success">
                            Add Suspects Details&nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'mask']"></font-awesome-icon>
                        </b-button>

                        <transition name="fade" mode="out-in">
                            <div v-if="addSuspect == true">
                                <suspectComponent v-on:addsuspect="addsuspect" v-on:cancelsuspect="CancelSuspect" />
                            </div>
                        </transition>
                        <transition name="fade" mode="out-in">
                            <div v-if="vm.suspects.listofSuspects.length >0 ">
                                <div v-for="(value, index) in vm.suspects.listofSuspects" v-bind:key="vm.suspects.listofSuspects[index].name">
                                    <ul>
                                        <li>
                                            <span class="npflink" v-b-toggle="'collapse-'+index">Suspect {{index+1}}</span>
                                        </li>

                                        <b-collapse :id="'collapse-'+index" class="mt-2">
                                            <b-card>
                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <span class="npfQuestion">Name:</span> {{value.Name}}
                                                        </b-col>
                                                    </b-row>
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <span class="npfQuestion">Gender:</span> {{value.Gender}}
                                                        </b-col>
                                                    </b-row>
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="6">
                                                            <span class="npfQuestion">Approximate age:</span> {{value.aproxAge}}
                                                        </b-col>
                                                        <b-col cols="6">
                                                            <span class="npfQuestion">Approximate height:</span> {{value.aproxHeight}}
                                                        </b-col>
                                                    </b-row>
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="6">
                                                            <span class="npfQuestion">Build:</span> {{value.build}}
                                                        </b-col>
                                                        <b-col cols="6">
                                                            <span class="npfQuestion">Eye colour:</span> {{value.eyecolour}}
                                                        </b-col>
                                                    </b-row>
                                                </b-form-group>

                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="6">
                                                            <span class="npfQuestion">Hair colour:</span> {{value.haircolour}}
                                                        </b-col>
                                                        <b-col cols="6">
                                                            <span class="npfQuestion">Hair style:</span> {{value.hairstyle}}
                                                        </b-col>
                                                    </b-row>
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <span class="npfQuestion">Ethnicity:</span> {{doesvalueexitsinEthnicity(value.ethnicity)}}
                                                        </b-col>

                                                    </b-row>
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-row>

                                                        <b-col cols="12">
                                                            <span class="npfQuestion">Any other details about the suspect:</span> {{value.OtherDeteails}}
                                                        </b-col>

                                                    </b-row>
                                                </b-form-group>

                                                <b-form-group>
                                                    <b-row>
                                                        <b-col cols="12">
                                                            <b-button @click="deleteSuspect(index)" variant="danger">
                                                                Delete
                                                                <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon>
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>
                                                </b-form-group>
                                            </b-card>
                                        </b-collapse>
                                    </ul>
                                </div>
                            </div>
                        </transition>

                    </b-card>

                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div id="page5" v-if="pageNum == 5">
                    <span class="stage">Stage 5 of 8</span>

                    <h1>About any personal belongings involved</h1>
                    <span class="npfSubQuestion">If any personal belongings were involved, please tell us about them. Otherwise, continue to the next page.</span>

                    <b-card class="cardboardTop" title="Were any personal belongings lost, stolen or damaged in the incident?">
                        <span class="npfSubQuestion">Select all that apply.</span>
                        <div class="npfQuestionDiv">
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <b-card class="clickable" v-on:click="vm.property.vehicle = !vm.property.vehicle" v-bind:class="{ npfactive: vm.property.vehicle == true  , npfnonActive :vm.property.vehicle == false }">
                                            <i class="far fa-square fa-lg" v-if="vm.property.vehicle == false">&nbsp;&nbsp;</i>

<i class="far fa-check-square fa-lg" v-if="vm.property.vehicle == true">&nbsp;&nbsp;</i>
                                            <input style="display:none;" type="checkbox" v-model="vm.property.vehicle">
                                            <span class="npfQuestion">A vehicle</span> <span v-if="vm.property.vehicle" class="npfHighlightRed"> (Please fill out the details below) </span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">For example, a car, motorbike or bicycle.</span>
                                        </b-card>
                                        <br>
                                        <b-card class="clickable" v-on:click="vm.property.electronicDevice = !vm.property.electronicDevice" v-bind:class="{ npfactive: vm.property.electronicDevice == true  , npfnonActive :vm.property.electronicDevice == false }">
                                                               <i class="far fa-square fa-lg" v-if="vm.property.electronicDevice == false">&nbsp;&nbsp;</i>

<i class="far fa-check-square fa-lg" v-if="vm.property.electronicDevice == true">&nbsp;&nbsp;</i>
                                            <input style="display:none;" type="checkbox" v-model="vm.property.electronicDevice">
                                            <span class="npfQuestion">An electronic device</span><span v-if="vm.property.electronicDevice" class="npfHighlightRed"> (Please fill out the details below) </span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">For example, a mobile phone, iPad, tablet or laptop computer.</span>
                                        </b-card>
                                        <br>
                                        <b-card class="clickable" v-on:click="vm.property.bagorwallet = !vm.property.bagorwallet" v-bind:class="{ npfactive: vm.property.bagorwallet == true  , npfnonActive :vm.property.bagorwallet == false }">
                                                               <i class="far fa-square fa-lg" v-if="vm.property.bagorwallet == false">&nbsp;&nbsp;</i>

<i class="far fa-check-square fa-lg" v-if="vm.property.bagorwallet == true">&nbsp;&nbsp;</i>
                                            <input style="display:none;" type="checkbox" v-model="vm.property.bagorwallet">
                                            <span class="npfQuestion">A bag or wallet</span><span v-if="vm.property.bagorwallet" class="npfHighlightRed"> (Please fill out the details below) </span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">For example, a purse, wallet, backpack, piece of luggage or any other bag.</span>
                                        </b-card>
                                        <br>
                                        <b-card class="clickable" v-on:click="vm.property.somthingelse = !vm.property.somthingelse" v-bind:class="{ npfactive: vm.property.somthingelse == true  , npfnonActive :vm.property.somthingelse == false }">
                                                             <i class="far fa-square fa-lg" v-if="vm.property.somthingelse == false">&nbsp;&nbsp;</i>

<i class="far fa-check-square fa-lg" v-if="vm.property.somthingelse == true">&nbsp;&nbsp;</i>
                                            <input style="display:none;" type="checkbox" v-model="vm.property.somthingelse">
                                            <span class="npfQuestion">Something else not in this list</span><span v-if="vm.property.somthingelse" class="npfHighlightRed"> (Please fill out the details below) </span>
                                            <br>
                                            <span class="npfSubQuestion npfpad">You can give more details below</span>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>
                    </b-card>

                    <transition name="fade" mode="out-in">
                        <div v-if="vm.property.vehicle == true">
                            <b-card class="cardboardTop" title="Vehicles Involved.">
                                <b-button v-if="vm.property.addvehicle == false" v-on:click="vehicleClickMainButton" variant="success">
                                    Add Vehicle&nbsp;&nbsp;
                                    <font-awesome-icon :icon="['fas', 'car']"></font-awesome-icon>
                                </b-button>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.property.addvehicle == true">
                                        <addvehiclecomponent v-on:addvehicle="addvehicleparent" v-on:cancelVehicle="CancelVehicle" />
                                    </div>
                                </transition>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.property.listofVehicles.length >0 ">
                                        <div v-for="(value, index) in vm.property.listofVehicles" v-bind:key="vm.property.listofVehicles[index].vrm">
                                            <ul>
                                                <li>
                                                    <span class="npflink" v-b-toggle="'collapse-'+index">Vehicle {{index+1}}</span>
                                                </li>

                                                <b-collapse :id="'collapse-'+index" class="mt-2">
                                                    <b-card>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Vehicle Type:</span> {{value.type}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Make and Model:</span> {{value.makeandModel}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Number plate or vehicle identification number:</span> {{value.VRM}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Any other information:</span> {{value.anyotherinfo}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <b-button @click="deleteVehicle(index)" variant="danger">
                                                                        Delete
                                                                        <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon>
                                                                    </b-button>
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                    </b-card>
                                                </b-collapse>
                                            </ul>
                                        </div>
                                    </div>
                                </transition>
                            </b-card>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div v-if="vm.property.electronicDevice == true">
                            <b-card class="cardboardTop" title="Electronic Devices Involved.">
                                <b-button v-if="vm.property.addElectronicDevice == false" v-on:click="addpropertyElectronicMain" variant="success">
                                    Add Electronic Devices&nbsp;&nbsp;
                                    <font-awesome-icon :icon="['fas', 'mobile-alt']"></font-awesome-icon>
                                </b-button>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.property.addElectronicDevice == true">
                                        <electronicdevice v-on:addpropertyelectronic="addpropertyelectronic" v-on:cancelpropertyelectronic="cancelpropertyelectronic" />
                                    </div>
                                </transition>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.property.listofelectronicDevice.length >0 ">
                                        <div v-for="(value, index) in vm.property.listofelectronicDevice" v-bind:key="vm.property.listofelectronicDevice[index].describeitem">
                                            <ul>
                                                <li>
                                                    <span class="npflink" v-b-toggle="'collapse-'+index">Electronic Device {{index+1}}</span>
                                                </li>

                                                <b-collapse :id="'collapse-'+index" class="mt-2">
                                                    <b-card>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Device Type:</span> {{value.type}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Make and model:</span> {{value.makeandmodel}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">IMEI code or serial number, if known:</span> {{value.imei}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Any other information:</span> {{value.anyother}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>

                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <b-button @click="deletePropertyelectronic(index)" variant="danger">
                                                                        Delete
                                                                        <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon>
                                                                    </b-button>
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                    </b-card>
                                                </b-collapse>
                                            </ul>
                                        </div>
                                    </div>
                                </transition>
                            </b-card>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div v-if="vm.property.bagorwallet == true">
                            <b-card class="cardboardTop" title="Bags or Wallets Involved.">
                                <b-button v-if="vm.property.addBagsorWallets == false" v-on:click="addpropertyMain" variant="success">
                                    Add Bags or Wallets&nbsp;&nbsp;
                                    <font-awesome-icon :icon="['fas', 'shopping-bag']"></font-awesome-icon>
                                </b-button>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.property.addBagsorWallets == true">
                                        <propertycomponent v-on:addproperty="addproperty" v-on:cancelproperty="cancelproperty" />
                                    </div>
                                </transition>

                                <transition name="fade" mode="out-in">
                                    <div v-if="vm.property.listofbagorwallet.length >0 ">
                                        <div v-for="(value, index) in vm.property.listofbagorwallet" v-bind:key="vm.property.listofbagorwallet[index].describeitem">
                                            <ul>
                                                <li>
                                                    <span class="npflink" v-b-toggle="'collapse-'+index">Property Item {{index+1}}</span>
                                                </li>

                                                <b-collapse :id="'collapse-'+index" class="mt-2">
                                                    <b-card>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Property Type:</span> {{value.type}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Description of Item:</span> {{value.describeitem}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <span class="npfQuestion">Description of any contents:</span> {{value.describecontents}}
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>

                                                        <b-form-group>
                                                            <b-row>
                                                                <b-col cols="12">
                                                                    <b-button @click="deleteProperty(index)" variant="danger">
                                                                        Delete
                                                                        <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon>
                                                                    </b-button>
                                                                </b-col>
                                                            </b-row>
                                                        </b-form-group>
                                                    </b-card>
                                                </b-collapse>
                                            </ul>
                                        </div>
                                    </div>
                                </transition>
                            </b-card>
                        </div>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <div v-if="vm.property.somthingelse == true">
                            <b-card class="cardboardTop" title="Other belongings involved.">
                                <span class="npfQuestion">Describe the items in as much detail as possible</span>
                                <br>
                                <span class="npfSubQuestion">For example, the colour, material, value, size, and any other information that can help identify them.</span>

                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-textarea v-model="vm.property.somthingelseDetails" placeholder="Describe the item remember to include Serial numbers if possible" rows="5" max-rows="12"></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </b-card>
                        </div>
                    </transition>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div id="page6" v-if="pageNum == 6">
                    <span class="stage">Stage 6 of 8</span>
                    <h1>About any evidence</h1>

                    <b-card class="cardboardTop" title="Is there any evidence from the incident or at the scene?">
                        <span class="npfSubQuestion">For example, photos, videos, fingerprints, blood, etc.</span>
                        <div class="npfQuestionDiv">
                            <b-form-group>
                                <b-row>
                                    <b-col cols="4">
                                        <b-card class="clickable" v-on:click="vm.evidence.anyevidence = 'Yes'" v-bind:class="{ npfactive:vm.evidence.anyevidence == 'Yes'  , npfnonActive :vm.evidence.anyevidence != 'Yes' }">
                                            <input type="radio" id="evidenceYes" value="Yes" v-model="vm.evidence.anyevidence">
                                            <span class="npfQuestion">Yes</span>
                                        </b-card>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-card class="clickable" v-on:click="vm.evidence.anyevidence = 'No'" v-bind:class="{ npfactive:vm.evidence.anyevidence == 'No'  , npfnonActive :vm.evidence.anyevidence != 'No' }">
                                            <input type="radio" id="evidenceNo" value="No" v-model="vm.evidence.anyevidence">
                                            <span class="npfQuestion">No</span>
                                        </b-card>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-card class="clickable" v-on:click="vm.evidence.anyevidence = 'Dont know'" v-bind:class="{ npfactive:vm.evidence.anyevidence == 'Dont know'  , npfnonActive :vm.evidence.anyevidence != 'Dont know' }">
                                            <input type="radio" id="evidenceDN" value="Dont know" v-model="vm.evidence.anyevidence">
                                            <span class="npfQuestion">Don't know</span>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>
                    </b-card>

                    <transition name="fade" mode="out-in">
                        <div v-if="vm.evidence.anyevidence == 'Yes'">
                            <b-card class="cardboardTop" title="Describe the evidence">
                                <b-form-group>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-textarea v-model="vm.evidence.describeEvidence" placeholder="Please provide as much information as possible" rows="5" max-rows="12"></b-form-textarea>
                                        </b-col>
                                    </b-row>
                                </b-form-group>
                            </b-card>
                        </div>
                    </transition>
                </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div id="page7" v-if="pageNum == 7">
                    <span class="stage">Stage 7 of 8</span>
                    <h1>Additional information</h1>

                    <b-card class="cardboardTop" title>
                        <b-form-group>
                            <b-row>
                                <b-col cols="12">
                                    <span class="npfQuestion">Is this related to any other crimes or incidents?</span>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="4">
                                    <b-card class="clickable" v-on:click="vm.additionalInfo.isthisrelatedtoanyothercrime = 'Yes'" v-bind:class="{ npfactive:vm.additionalInfo.isthisrelatedtoanyothercrime == 'Yes'  , npfnonActive :vm.additionalInfo.isthisrelatedtoanyothercrime != 'Yes' }">
                                        <input type="radio" id="aiYes" value="Yes" v-model="vm.additionalInfo.isthisrelatedtoanyothercrime">
                                        <span class="npfQuestion">Yes</span>
                                    </b-card>
                                </b-col>
                                <b-col cols="4">
                                    <b-card class="clickable" v-on:click="vm.additionalInfo.isthisrelatedtoanyothercrime = 'No'" v-bind:class="{ npfactive:vm.additionalInfo.isthisrelatedtoanyothercrime == 'No'  , npfnonActive :vm.additionalInfo.isthisrelatedtoanyothercrime != 'No' }">
                                        <input type="radio" value="No" v-model="vm.additionalInfo.isthisrelatedtoanyothercrime">
                                        <span class="npfQuestion">No</span>
                                    </b-card>
                                </b-col>
                                <b-col cols="4">
                                    <b-card class="clickable" v-on:click="vm.additionalInfo.isthisrelatedtoanyothercrime = 'Dont know'" v-bind:class="{ npfactive:vm.additionalInfo.isthisrelatedtoanyothercrime == 'Dont know'  , npfnonActive :vm.additionalInfo.isthisrelatedtoanyothercrime != 'Dont know' }">
                                        <input type="radio" value="Dont know" v-model="vm.additionalInfo.isthisrelatedtoanyothercrime">
                                        <span class="npfQuestion">Don't know</span>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <transition name="fade" mode="out-in">
                            <div v-if="vm.additionalInfo.isthisrelatedtoanyothercrime == 'Yes'">
                                <b-card class="cardboardTop" title="Briefly list the previous crimes or incidents">
                                    <b-form-group>
                                        <b-row>
                                            <b-col cols="12">
                                                <span class="npfSubQuestion">Include any relevant dates, times and reference numbers.</span>
                                                <b-form-textarea v-model="vm.additionalInfo.isthisrelatedtoanyothercrimeDetails" placeholder="Please provide as much information as possible" rows="5" max-rows="12"></b-form-textarea>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-card>
                            </div>
                        </transition>
                        <div class="npfQuestionDiv">
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <span class="npfQuestion">Do you feel you're being targeted?</span>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="4">
                                        <b-card class="clickable" v-on:click="vm.additionalInfo.doyoufeelyourbeingtargeted = 'Yes'" v-bind:class="{ npfactive:vm.additionalInfo.doyoufeelyourbeingtargeted == 'Yes'  , npfnonActive :vm.additionalInfo.doyoufeelyourbeingtargeted != 'Yes' }">
                                            <input type="radio" id="aiYes" value="Yes" v-model="vm.additionalInfo.doyoufeelyourbeingtargeted">
                                            <span class="npfQuestion">Yes</span>
                                        </b-card>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-card class="clickable" v-on:click="vm.additionalInfo.doyoufeelyourbeingtargeted = 'No'" v-bind:class="{ npfactive:vm.additionalInfo.doyoufeelyourbeingtargeted == 'No'  , npfnonActive :vm.additionalInfo.doyoufeelyourbeingtargeted != 'No' }">
                                            <input type="radio" value="No" v-model="vm.additionalInfo.doyoufeelyourbeingtargeted">
                                            <span class="npfQuestion">No</span>
                                        </b-card>
                                    </b-col>
                                    <b-col cols="4">
                                        <b-card class="clickable" v-on:click="vm.additionalInfo.doyoufeelyourbeingtargeted = 'Dont know'" v-bind:class="{ npfactive:vm.additionalInfo.doyoufeelyourbeingtargeted == 'Dont know'  , npfnonActive :vm.additionalInfo.doyoufeelyourbeingtargeted != 'Dont know' }">
                                            <input type="radio" value="Dont know" v-model="vm.additionalInfo.doyoufeelyourbeingtargeted">
                                            <span class="npfQuestion">Don't know</span>
                                        </b-card>
                                    </b-col>
                                </b-row>
                            </b-form-group>

                            <transition name="fade" mode="out-in">
                                <div v-if="vm.additionalInfo.doyoufeelyourbeingtargeted == 'Yes'">
                                    <b-card class="cardboardTop" title="Tell us why you feel you're being targeted">
                                        <b-form-group>
                                            <b-row>
                                                <b-col cols="12">
                                                    <b-form-textarea v-model="vm.additionalInfo.doyoufeelyourbeingtargetedDetails" placeholder="Please provide as much information as possible" rows="5" max-rows="12"></b-form-textarea>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </b-card>
                                </div>
                            </transition>
                        </div>

                        <div class="npfQuestionDiv">
                            <b-form-group>
                                <b-row>
                                    <b-col cols="12">
                                        <span class="npfQuestion">Is there any other information you think may be relevant?</span>
                                        <b-form-textarea v-model="vm.additionalInfo.isthereanyotherrelevantinformation" placeholder="Please provide as much information as possible" rows="5" max-rows="12"></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>
                    </b-card>
                </div>
            </transition>

            <transition name="fade" mode="out-in">
                <div id="page8" v-if="pageNum == 8">
                    <span class="stage">Stage 8 of 8</span>
                    <summaryForm :viewModel="vm" v-on:gotToedit="gotToedit"></summaryForm>
                </div>
            </transition>

            <transition name="fade" mode="out-in">
                <div id="buttons" v-if="pageNum > 0 && pageNum <8 && NavButtons">
                    <div class="nextbuttons">
                        <b-button size="lg" variant="primary" v-on:click="prevPage">
                            <font-awesome-icon :icon="['fas', 'backward']"></font-awesome-icon>&nbsp;&nbsp; Back
                        </b-button>&nbsp;&nbsp;
                        <b-button size="lg" variant="success" v-on:click="nextPage">
                            Next&nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'forward']"></font-awesome-icon>
                        </b-button>&nbsp;&nbsp;

                        <b-button size="lg" variant="secondary" v-if="showjumptoendbutton" v-on:click="JumpToEndButtonClick">
                            Jump back to end&nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'step-forward']"></font-awesome-icon>
                        </b-button>
                        <br>
                        <br>
                        </div>
                    </div>
            </transition>
            <transition name="fade" mode="out-in">
                <div id="buttons" v-if="pageNum == 8">
                    <div class="nextbuttons">
                        <b-button size="lg" variant="success" v-on:click="Submit">
                            Submit&nbsp;&nbsp;
                            <font-awesome-icon :icon="['fas', 'share']"></font-awesome-icon>
                        </b-button>
                        <br>
                        <br>
                        </div>
                    </div>
            </transition>

            <transition name="fade" mode="out-in">
                <div id="page9" v-if="pageNum == 9">
                    <div v-if="submissionError == false">
                        <div>
                            <b-alert show variant="success">
                                <h4 class="alert-heading">
                                    <font-awesome-icon :icon="['fas', 'thumbs-up']"></font-awesome-icon> &nbsp;&nbsp;Submitted!
                                </h4>
                                <p>Thank you for your online report. The information contained in the report will be assessed and you will be contacted by phone or e-mail in order to provide you with an update. We aim to review all online reports within 24 hours. If an update is required on your report prior to an Officer contacting you, please e-mail <a href="mailto:tib@nottinghamshire.pnn.police.uk">tib@nottinghamshire.pnn.police.uk</a> and quote your reference number in the subject field of the e-mail. If you have any documentary evidence or CCTV evidence could you please send this to <a href="mailto:tib@nottinghamshire.pnn.police.uk">tib@nottinghamshire.pnn.police.uk</a> so that it can be reviewed when dealing with your report.
                                    If your report relates to a crime that is happening now and people are in danger or injured, please call 999.
                                </p>
                                <hr>
                                <p class="mb-0">If you have need any further information please contact 101.</p>
                            </b-alert>
                        </div>
                    </div>
                    <div v-if="submissionError == true">
                        <div>
                            <b-alert show variant="danger">
                                <h4 class="alert-heading">
                                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']"></font-awesome-icon> &nbsp;&nbsp;Error!
                                </h4>
                                <p><b>There has been an error submiting this crime to Nottinghamshire Police. <br>You have several options below</b></p>
                                <hr>
                                <p class="mb-0">
                                    <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon> &nbsp;&nbsp;Try to submit again using the button below
                                </p>
                                <br>
                                <div class="npfmiddle">
                                    <b-button size="lg" variant="success" v-on:click="Submit">
                                        Submit&nbsp;&nbsp;
                                        <font-awesome-icon :icon="['fas', 'share']"></font-awesome-icon>
                                    </b-button>
                                </div>
                                <br>
                                <br>

                                <hr>
                                <p class="mb-0">
                                    <font-awesome-icon :icon="['fas', 'caret-right']"></font-awesome-icon> &nbsp;&nbsp;Contact Nottinghamshire police on 101 to report your non urgent crime
                                </p>
                            </b-alert>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div>
            Submission ID: {{vm.uniqueID}}
        </div>

    </b-container>

</div>
</template>

<script>
import headercomponent from "./components/headerComponent.vue";
import addvehiclecomponent from "./components/VehicleComponent.vue";
import propertycomponent from "./components/BagsOrWalletsComponent.vue";
import electronicdevice from "./components/ElectronicDeviceComponent.vue";
import summaryForm from "./components/SumaryComponent.vue";

import suspectComponent from "./components/SuspectComponent.vue";
import datePicker from 'vue-bootstrap-datetimepicker';
import {
    uuid
} from 'vue-uuid' // Import uuid

const axios = require('axios');
const CryptoJS = require("crypto-js");
const cyrtokeyClient = "JaNdRfUjXn2r5u8x/A?D(G+KbPeShVkY";
// eslint-disable-next-line
const moment = require('vue-moment'); 

export default {
    name: "app",
    components: {
        headercomponent,
        addvehiclecomponent,
        propertycomponent,
        electronicdevice,
        summaryForm,
        suspectComponent,
        datePicker
    },
    computed: {
        cleanedAnwser: function (Ethnicity) {

            var rval = "";
// eslint-disable-next-line
            this.ethnicity.forEach(function (value, key) {
                if (value.value === Ethnicity) rval = value.text;
            });

            return rval;
        }
    },
    data() {
        return {
            msg: "Welcome to Your Vue.js App",
            pageNum: 0,
            validationErrors: false,
            validationErrorsMessage: [],
            mandatoryText: "(Mandatory)",
            randomNumberValue: 0,
            submissionError: false,
            addSuspect: false,
            NavButtons: true,
            showjumptoendbutton: false,
            vm: {
                uniqueID: uuid.v1(),
                doyouknowntoVic: false,
                typeOfIndident: "",
                ReportingPerson: {
                    title: "",
                    firstname: "",
                    middlename: "",
                    surname: "",
                    phonenumber: "",
                    phonenumberother: "",
                    email: "",
                    dob:"",
                    dobday: "",
                    dobmonth: "",
                    dobyear: "",
                    Address: {
                        BuidlingName: "",
                        BuildingNumber: "",
                        Street: "",
                        Town: "",
                        County: "",
                        PostCode: "",
                        NotProvideAddress: false
                    },
                    gender: "",
                    ethnicity: "",
                    ethiciitysub: "",
                    disability: "",
                    disabilityDetails: ""
                },
                Victim: {
                    vicType: "",
                    orgName: "",
                    orgContactPerson: "",
                    orgContactDetails: "",
                    title: "",
                    firstname: "",
                    middlename: "",
                    surname: "",
                    phonenumber: "",
                    phonenumberother: "",
                    email: "",
                      dob:"",
                    dobday: "",
                    dobmonth: "",
                    dobyear: "",
                    Address: {
                        BuidlingName: "",
                        BuildingNumber: "",
                        Street: "",
                        Town: "",
                        County: "",
                        PostCode: "",
                        NotProvideAddress: false
                    },
                    gender: "",
                    ethnicity: "",
                    ethiciitysub: "",
                    disability: "",
                    disabilityDetails: ""
                },
                incident: {
                    typeOfIncident: [],
startDateTime:new Date(),
endDateTime:new Date(),
                    startday: new Date().getDate(),
                    startmonth: new Date().getMonth(),
                    startyear: new Date().getFullYear(),
                    startTime: new Date().getHours() + ":" + new Date().getMinutes(),
                    endday: new Date().getDate(),
                    endmonth: new Date().getMonth(),
                    endyear: new Date().getFullYear(),
                    endtime: new Date().getHours() + ":" + new Date().getMinutes(),
                    Address: {
                        BuidlingName: "",
                        BuildingNumber: "",
                        Street: "",
                        Town: "",
                        County: "",
                        PostCode: "",
                        NotProvideAddress: false
                    },
                    decriptionOfLocation: "",
                    decribeIncident: ""
                },
                suspects: {
                    anysuspects: false,
                    listofSuspects: []
                },
                property: {
                    vehicle: false,
                    electronicDevice: false,
                    bagorwallet: false,
                    somthingelse: false,
                    listofVehicles: [],
                    listofelectronicDevice: [],
                    listofbagorwallet: [],
                    somthingelseDetails: "",
                    addvehicle: false,
                    addBagsorWallets: false,
                    addElectronicDevice: false
                },
                evidence: {
                    anyevidence: "",
                    describeEvidence: ""
                },
                additionalInfo: {
                    isthisrelatedtoanyothercrime: "",
                    isthisrelatedtoanyothercrimeDetails: "",
                    doyoufeelyourbeingtargeted: "",
                    doyoufeelyourbeingtargetedDetails: "",
                    isthereanyotherrelevantinformation: ""
                }
            },
            tracker: "",
            victimType: [{
                    value: "",
                    text: "*** Please Select ***"
                },
                {
                    value: "Person",
                    text: "Person"
                },
                {
                    value: "Organisation",
                    text: "Organisation"
                }

            ],
            ethnicity: [{
                    value: "",
                    text: "*** Please Select ***"
                },
                {
                    value: "A09",
                    text: "Any other Asian background"
                },
                {
                    value: "B09",
                    text: "Any other Black background"
                },
                {
                    value: "O09",
                    text: "Any other ethnic group"
                },
                {
                    value: "M09",
                    text: "Any other mixed background"
                },
                {
                    value: "W09",
                    text: "Any other white background"
                },
                {
                    value: "A2H",
                    text: "Arab"
                },
                {
                    value: "A03",
                    text: "Asian - Bangladeshi"
                },
                {
                    value: "A01",
                    text: "Asian - Indian"
                },
                {
                    value: "A02",
                    text: "Asian - Pakistani"
                },
                {
                    value: "B02",
                    text: "Black African"
                },
                {
                    value: "B01",
                    text: "Black Caribbean"
                },
                {
                    value: "O01",
                    text: "Chinese"
                },
                {
                    value: "G02",
                    text: "Gypsy or Irish Traveller"
                },
                {
                    value: "N03",
                    text: "Prefer not to say"
                },
                {
                    value: "M03",
                    text: "White & Asian"
                },
                {
                    value: "M02",
                    text: "White & Black African"
                },
                {
                    value: "M01",
                    text: "White & Black Caribbean"
                },
                {
                    value: "W01",
                    text: "White British"
                },
                {
                    value: "W02",
                    text: "White Irish"
                }
            ],
            options: {
                format: 'DD/MM/YYYY',
                useCurrent: true,
                sideBySide: false,
                showTodayButton: true,
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            },
            optionsPreviousDate: {
                format: 'DD/MM/YYYY',
                useCurrent: false,
                sideBySide: false,
                showTodayButton: true,
                minDate:"1900-01-01",
                maxDate:new Date(new Date().setDate(new Date().getDate())),
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            },
            options2: {
                format: 'HH:mm',
                useCurrent: true,
                sideBySide: false,
                showTodayButton: true,
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            },
            optionsdt: {
                format: 'DD/MM/YYYY HH:mm',
                useCurrent: true,
                sideBySide: true,
                showTodayButton: true,
                icons: {

                    time: 'far fa-clock',
                    date: 'far fa-calendar',
                    up: 'fas fa-arrow-up',
                    down: 'fas fa-arrow-down',
                    previous: 'fas fa-chevron-left',
                    next: 'fas fa-chevron-right',
                    today: 'fas fa-calendar-check',
                    clear: 'far fa-trash-alt',
                    close: 'far fa-times-circle'

                },
                showClear: true,
                showClose: true,
            }
        };
    },
    methods: {

        test1() {
            this.swal("Good job!", "You clicked the button!", "success");
        },
        test2() {
            this.$swal("Hello Vue world!!!", "dave", "error");
        },
        showAlert() {
            // Use sweetalert2
            this.$swal("Hello Vue world!!!", "dave", "error");
        },
        // log: function (log) {
        //     console.log(log);
        // },
        TypeofIncidentClicked(incident) {
            //console.log(incident);

            var ind = this.vm.incident.typeOfIncident.indexOf(incident);
            //console.log(ind);
            if (ind > -1) {
                this.vm.incident.typeOfIncident.splice(ind, 1);
            } else {
                this.vm.incident.typeOfIncident.push(incident);
            }

        },
        addsuspectMainButton() {
            this.addSuspect = true;
            this.HideNavButtons(false);

        },
        addsuspect(suspect) {
            this.vm.suspects.listofSuspects.push(suspect);
            this.addSuspect = false;
            this.HideNavButtons(true);

        },

        deleteSuspect: function (index) {
            this.vm.suspects.listofSuspects.splice(index, 1);
        },

        CancelSuspect() {
            this.addSuspect = false;
            this.HideNavButtons(true);
        },
        vehicleClickMainButton() {
            this.vm.property.addvehicle = true;
            this.HideNavButtons(false);
        },
        addvehicleparent(veh) {
            this.vm.property.listofVehicles.push(veh);
            this.vm.property.addvehicle = false;
            this.HideNavButtons(true);
            //this.$swal("Hello Vue world!!!", veh, "error");
        },

        deleteVehicle: function (index) {
            this.vm.property.listofVehicles.splice(index, 1);
        },

        CancelVehicle() {
            this.vm.property.addvehicle = false;
            this.HideNavButtons(true);
        },
        addpropertyMain() {
            this.vm.property.addBagsorWallets = true;
            this.HideNavButtons(false);
        },
        addproperty(property) {
            this.vm.property.listofbagorwallet.push(property);
            this.vm.property.addBagsorWallets = false;
            this.HideNavButtons(true);
        },

        deleteProperty: function (index) {
            this.vm.property.listofbagorwallet.splice(index, 1);
        },

        cancelproperty() {
            this.vm.property.addBagsorWallets = false;
            this.HideNavButtons(true);
        },
        addpropertyElectronicMain() {
            this.vm.property.addElectronicDevice = true;
            this.HideNavButtons(false);
        },
        addpropertyelectronic(property) {
            this.vm.property.listofelectronicDevice.push(property);
            this.vm.property.addElectronicDevice = false;
            this.HideNavButtons(true);
        },

        deletePropertyelectronic: function (index) {
            this.vm.property.listofelectronicDevice.splice(index, 1);
        },

        cancelpropertyelectronic() {
            this.vm.property.addElectronicDevice = false;
            this.HideNavButtons(true);
        },
        HideNavButtons(val) {
            this.NavButtons = val;
        },
        JumpToEndButtonClick() {
            this.pageNum = 8;
        },
        nextPage() {
            this.validatepage();

            if (!this.validationErrors) {
                this.pageNum++;
                window.scrollTo(0, 0);
            } else {
                this.errorMessage();
            }
        },
        prevPage() {
            this.pageNum--;
            window.scrollTo(0, 0);
        },
        toggleboolen(value) {
            //console.log(value);
            if (value == true) {
                //console.log(value);
                value = false;
            } else {
                // console.log(value);
                value = true;
            }
            //console.log(value);
        },
        doesvalueexitsinEthnicity: function (val) {
            var rval = "";
// eslint-disable-next-line
            this.ethnicity.forEach(function (value, key) {
                if (value.value === val) rval = value.text;
            });

            return rval;
        },
        errorMessage() {
            var errormessage = this.validationErrorsMessage;
            var htmlerror = "<div style='text-align: left;'><ul>";
            errormessage.forEach(function (item) {
                htmlerror += "<li>" + item + "</li>";
            });
            htmlerror += "</ul></div>";
            window.scrollTo(0, 0);
            this.$swal("Validation Error(s)", htmlerror, "error");
        },
        validatepage() {
            this.validationErrors = false;
            this.validationErrorsMessage = [];

            if (this.pageNum == 1) {
                this.ValidatePage1();
            }
            if (this.pageNum == 2) {
                this.ValidatePage2();
            }
            if (this.pageNum == 3) {
                this.ValidatePage3();
            }
            if (this.pageNum == 6) {
                this.ValidatePage6();
            }
            if (this.pageNum == 7) {
                this.ValidatePage7();
            }
        },
        ValidatePage1() {
            if (this.vm.typeOfIndident == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must select what kind of incident you are selecting before you can continue"
                );
            }
        },
        ValidatePage2() {
            if (this.vm.ReportingPerson.firstname == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push("Your First Name is required");
            }
            if (this.vm.ReportingPerson.surname == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push("Your Surname is required");
            }
               if (this.vm.ReportingPerson.dob == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "Data of Birth is required - please add date of birth"
                );
               }
            // if (this.vm.ReportingPerson.dobday == "") {
            //     this.validationErrors = true;
            //     this.validationErrorsMessage.push(
            //         "Data of Birth is required - please add date eg 01 for the 1st"
            //     );
            // } else if (this.vm.ReportingPerson.dobday != null && this.vm.ReportingPerson.dobday.length > 2) {
            //     this.validationErrors = true;
            //     this.validationErrorsMessage.push(
            //         "Data of Birth needs to be a valid date - please add date eg 01 for the 1st it can not be greater than 31"
            //     );
            // }
            // if (this.vm.ReportingPerson.dobmonth == "") {
            //     this.validationErrors = true;
            //     this.validationErrorsMessage.push(
            //         "Data of Birth is required - please add month e.g. 04 for April"
            //     );
            // } else if (this.vm.ReportingPerson.dobmonth != null && this.vm.ReportingPerson.dobmonth.length > 2) {
            //     this.validationErrors = true;
            //     this.validationErrorsMessage.push(
            //         "Data of Birth needs to be a valid date - please add month e.g. 04 for April"
            //     );
            // }
            // if (this.vm.ReportingPerson.dobyear == "") {
            //     this.validationErrors = true;
            //     this.validationErrorsMessage.push(
            //         "Data of Birth is required - please add Year e.g. 1983"
            //     );
            // } else if (this.vm.ReportingPerson.dobyear != null && this.vm.ReportingPerson.dobyear.length < 2) {
            //     this.validationErrors = true;
            //     this.validationErrorsMessage.push(
            //         "Data of Birth is required - please add full year e.g. 1983"
            //     );
            // }
            if (this.vm.ReportingPerson.email == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push("Email Address is required");
            }
            if (
                this.vm.ReportingPerson.Address.Street == "" &&
                this.vm.ReportingPerson.Address.NotProvideAddress == false
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push("Address - Street is required");
            }
            if (
                this.vm.ReportingPerson.Address.Town == "" &&
                this.vm.ReportingPerson.Address.NotProvideAddress == false
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push("Address - Town is required");
            }
            if (
                this.vm.ReportingPerson.Address.PostCode == "" &&
                this.vm.ReportingPerson.Address.NotProvideAddress == false
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push("Address - PostCode is required");
            }
        },
        ValidatePage3() {
            if (
                this.vm.incident.decriptionOfLocation == "" &&
                this.vm.incident.Address.NotProvideAddress == false
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must describe the location of this incident"
                );
            }
            if (
                this.vm.incident.Address.NotProvideAddress == true &&
                this.vm.incident.Address.Street == ""
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "Incident Address - Street is required"
                );
            }
            if (
                this.vm.incident.Address.NotProvideAddress == true &&
                this.vm.incident.Address.Town == ""
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "Incident Address - Town is required"
                );
            }
            if (
                this.vm.incident.Address.NotProvideAddress == true &&
                this.vm.incident.Address.PostCode == ""
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "Incident Address - PostCode is required"
                );
            }
            if (this.vm.incident.decribeIncident == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push("You must describe the incident");
            }
        },
        ValidatePage6() {
            if (this.vm.evidence.anyevidence == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must say if you think there is any evidence left at the scence"
                );
            }
            if (
                this.vm.evidence.anyevidence == "Yes" &&
                this.vm.evidence.describeEvidence == ""
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "Please give details about the evidence left at the scence"
                );
            }
        },
        ValidatePage7() {
            if (this.vm.additionalInfo.doyoufeelyourbeingtargeted == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must say if you think this is related to any other crimes or incidents"
                );
            }
            if (
                this.vm.additionalInfo.doyoufeelyourbeingtargeted == "Yes" &&
                this.vm.additionalInfo.doyoufeelyourbeingtargetedDetails == ""
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must give details why you think this is related to any other crimes or incidents"
                );
            }
            if (this.vm.additionalInfo.isthisrelatedtoanyothercrime == "") {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must say if you think you are being targeted"
                );
            }
            if (
                this.vm.additionalInfo.isthisrelatedtoanyothercrime == "Yes" &&
                this.vm.additionalInfo.isthisrelatedtoanyothercrimeDetails == ""
            ) {
                this.validationErrors = true;
                this.validationErrorsMessage.push(
                    "You must give details why you think you are being targeted"
                );
            }
        },
        gotToedit(pagnum) {
            this.pageNum = pagnum;
            this.showjumptoendbutton = true;
            window.scrollTo(0, 0);
        },
        randomNumber: function () {
            this.randomNumberValue = Math.floor(Math.random() * (10 - 1) + 1);
        },
        SubmittoService() {
            this.randomNumber();
            this.pageNum = 9;

            if (this.randomNumberValue < 4) {
                //fail
                this.submissionError = true;
                this.$swal("Error!!!", "There has been an error", "error");
            } else {
                this.submissionError = false;
                this.$swal("Submitted!!!", "This has been submited", "success");
            }
        },
        Submit() {
            var npfapp = this;

            var vmObject = JSON.stringify(this.vm);
            var UniqueID = this.vm.uniqueID;

            var onetimeKey = cyrtokeyClient + UniqueID.toString();
            //console.log(onetimeKey);
            var ciphertext = CryptoJS.AES.encrypt(vmObject, onetimeKey);
            // console.log(ciphertext.toString());

            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you have filled in all the information to the best of your knowledge, if you continue this will submit this to Nottinghamshire Police!",
                type: "question",
                showCancelButton: true,
                confirmButtonColor: "#0FA700",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, submit it!",
                cancelButtonText: "No, cancel!",
                buttonsStyling: true
            }).then(function (isConfirm) {
                if (isConfirm.value === true) {

                    axios.post('https://0zt2pk9rk3.execute-api.eu-west-2.amazonaws.com/Prod/oncrnpf', {
                            "data": ciphertext.toString(),
                            "subject": "NPF ONCR - Submission ID:" + UniqueID.toString()
                        }, {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Content-Type': 'application/json',

                            }
                        })
                        .then(function () {

                            npfapp.pageNum = 9;

                            npfapp.submissionError = false;

                        })
                        .catch(function () {
                            npfapp.pageNum = 9;
                            npfapp.submissionError = true;

                        });

                }

            });

        }
    }
};
</script>

<style lang="scss">
#app {
    font-family: "Arial";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    margin-top: 10px;
    padding-left: 10px;
}

.callout {
    border-left: 5px solid #086eb8;
    margin: 2.1em 0 2.1em;
    padding-left: 13.33333333px;
    background-color: #12003c;
    color: #ffffff;
    padding-top: 10px;
    padding-bottom: 10px;
}

.calloutRed {
    border-left: 5px solid #ff0000;
    margin: 2.1em 0 2.1em;
    padding-left: 13.33333333px;
    background-color: #e6b0aa;
    padding-top: 10px;
    padding-bottom: 10px;
}

.startbutton {
    padding-left: 20px;
}

.nextbuttons {
    padding-left: 20px;
    padding-top: 20px;
}

.stage {
    font-weight: bold;
}

.npfcontainer {
    padding-top: 10px;
}

input[type="radio"i] {
    zoom: 1.5;
}

input[type="checkbox"i] {
    zoom: 1.5;
}

.npfnonActive {
    background-color: #bfbfbf;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.npfnonActiveColourOnly {
    background-color: #bfbfbf;
}

.npfactiveColourOnly {
    background-color: lightgreen;
}

.npfpad {
    padding-left: 20px;
}

.npfactive {
    background-color: lightgreen;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
}

.errorCard {
    background-color: lightcoral;
    margin-bottom: 10px;
}

.npfQuestion {
    font-weight: bold;
}

.npfHighlightRed {
    font-style: italic;
    color: red;
}

.mandatory {
    font-style: italic;
    color: red;
}

.npfQuestionDiv {
    padding-top: 45px !important;
}

.npfMainQuestion {
    font-weight: bolder;
    font-size: 130%;
    padding-bottom: 10px;
}

.npfSubQuestion {
    font-weight: lighter;
    font-style: italic;
    color: #2c3e50;
}

.npfconfirm {
    border-left: 4px solid #595959;
    color: #595959;
    padding-top: 5px;
    padding-bottom: 5px;
    margin: 0.7em 0;
    padding-left: 13px;
    background-color: #cecccc;
}

.npfcheckbox {
    zoom: 1.5;
}

.boldFont {
    font-weight: bold;
}

ul {
    list-style-type: disc;
}

li {
    padding-top: 10px;
    font-weight: bold;
}

.cardboardTop {
    margin-top: 10px;
    background-color: #f7f4f4;
}

.swal-modal {
    background-color: rgba(63, 255, 106, 0.69);
    border: 3px solid white;
}

.clickable {
    cursor: pointer;
}

.npflink {
    cursor: pointer;
    color: blue;
    padding-top: 10px;
    padding-bottom: 10px;
    text-decoration: underline;
}

.npfmiddle {
    text-align: center;
}
</style>
